import { createRouter, createWebHistory } from 'vue-router';
import { InteractionSummary } from '../components';
import { RoleGuard } from '@agyletime/vue-3-common/src/routes/guard';
import { SessionGuard } from '@agyletime/vue-3-common/src/routes/guard';
import { PageTitleSetter } from '@agyletime/vue-3-common/src/routes/guard';
import { FeatureFlowGuard } from '@agyletime/vue-3-common/src/routes/guard';
// let beforeEnterGuard: any[] = [ RoleGuard(['view_interactions_summary'], true), FeatureFlowGuard('workload-interaction-report-link-and-routes') ];

// if (import.meta.env?.VITE_IS_GUARD_DISABLED === 'true') {
//   beforeEnterGuard = [];
// }

export const router = createRouter({
    // In dev we want to have the base (which has no CDN url) as vue-apps/vue_3_base/ or so and in prod
    // we want to avoid having https://website.com/https://cdn.website.com/vue-apps/vue_3_base/ as the
    // main portion is handled elsewhere. The `vue_3_base` portion is set using VITE_HISTORY_BASE_URL.
    // TODO: Propagate this change to other MFEs
    history: createWebHistory(import.meta.env.VITE_HISTORY_BASE_URL),
    routes: [
        {
            path: '/',
            name: 'Interactions Summary',
            component: InteractionSummary,
            // beforeEnter: beforeEnterGuard,
            // @ts-expect-error expected
            beforeEnter: async () => {
                const can = await RoleGuard(['view_interactions_summary'], true);
                return FeatureFlowGuard('workload-interaction-report-link-and-routes') && can;
            },
            meta: { title: 'Workstream Interaction Summary' }
        }
    ]
});

router.beforeEach(SessionGuard);
router.beforeEach(PageTitleSetter);